export class IntegrationSpecs {
    keys = []; // IntegrationKey

    constructor() {
        this.keys = [];
    }
}
